import React, { useState } from 'react';

export default function AdminStaff({
  token,

  staffData,
  staffLoading,
  staffError,

  staffEmail,
  setStaffEmail,
  staffName,
  setStaffName,
  staffPhone,
  setStaffPhone,
  staffRole,
  setStaffRole,

  staffBgStatus,
  setStaffBgStatus,
  staffBgDate,
  setStaffBgDate,

  staffMrStatus,
  setStaffMrStatus,
  staffMrDate,
  setStaffMrDate,

  staffNotes,
  setStaffNotes,

  staffRateType,
  setStaffRateType,
  staffRateAmount,
  setStaffRateAmount,

  fetchStaff,
  upsertStaff,
  loadStaffIntoForm
}) {
  const rows = Array.isArray(staffData?.rows) ? staffData.rows : [];
  const statusOptions = ['Pending', 'Complete', 'N/A'];
  const [staffModal, setStaffModal] = useState({ open: false, staff: null });

  // clear unused fields so they don't accidentally get sent/saved
  // ✅ keep role now (do NOT clear it)
  const clearUnusedFields = () => {
    if (typeof setStaffBgDate === 'function') setStaffBgDate('');
    if (typeof setStaffMrDate === 'function') setStaffMrDate('');
    if (typeof setStaffNotes === 'function') setStaffNotes('');
  };

  const handleUpsert = () => {
    clearUnusedFields();
    upsertStaff();
  };

  return (
    <div style={{ marginTop: 14 }}>
      <h2 style={{ margin: '6px 0 10px 0' }}>Staff</h2>

      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
      </div>

      {staffLoading && <div style={{ marginTop: 10 }}>Loading staff…</div>}
      {staffError ? (
        <div className="error" style={{ marginTop: 10 }}>
          {staffError}
        </div>
      ) : null}

      <div style={{ marginTop: 12, border: '1px solid #eee', borderRadius: 10, padding: 12, background: '#fff' }}>
        {/* Row 1: Name, Email, Phone, Role */}
        <div style={{ display: 'grid', gap: 10, gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))' }}>
          <div style={{ minWidth: 0 }}>
            <div style={{ fontSize: 12, color: '#666', marginBottom: 6 }}>Name</div>
            <input
              type="text"
              value={staffName}
              onChange={(e) => setStaffName(e.target.value)}
              placeholder="Full name"
              style={{
                width: '100%',
                padding: '10px 12px',
                borderRadius: 8,
                border: '1px solid #ddd',
                boxSizing: 'border-box'
              }}
            />
          </div>

          <div style={{ minWidth: 0 }}>
            <div style={{ fontSize: 12, color: '#666', marginBottom: 6 }}>Email (required)</div>
            <input
              type="email"
              value={staffEmail}
              onChange={(e) => setStaffEmail(e.target.value)}
              placeholder="name@email.com"
              style={{
                width: '100%',
                padding: '10px 12px',
                borderRadius: 8,
                border: '1px solid #ddd',
                boxSizing: 'border-box'
              }}
            />
          </div>

          <div style={{ minWidth: 0 }}>
            <div style={{ fontSize: 12, color: '#666', marginBottom: 6 }}>Phone</div>
            <input
              type="text"
              value={staffPhone}
              onChange={(e) => setStaffPhone(e.target.value)}
              placeholder="(555) 555-5555"
              style={{
                width: '100%',
                padding: '10px 12px',
                borderRadius: 8,
                border: '1px solid #ddd',
                boxSizing: 'border-box'
              }}
            />
          </div>

          <div style={{ minWidth: 0 }}>
            <div style={{ fontSize: 12, color: '#666', marginBottom: 6 }}>Role</div>
            <input
              type="text"
              value={staffRole}
              onChange={(e) => setStaffRole(e.target.value)}
              placeholder="e.g. Counselor, Nurse, Kitchen, Security"
              style={{
                width: '100%',
                padding: '10px 12px',
                borderRadius: 8,
                border: '1px solid #ddd',
                boxSizing: 'border-box'
              }}
            />
          </div>
        </div>

        {/* Row 2: Background Status + Mandated Reporter Status (no dates) */}
        <div
          style={{
            marginTop: 10,
            display: 'grid',
            gap: 10,
            gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))'
          }}
        >
          <div style={{ minWidth: 0 }}>
            <div style={{ fontSize: 12, color: '#666', marginBottom: 6 }}>Background Status</div>
            <select
              value={staffBgStatus}
              onChange={(e) => setStaffBgStatus(e.target.value)}
              style={{
                width: '100%',
                padding: '10px 12px',
                borderRadius: 8,
                border: '1px solid #ddd',
                boxSizing: 'border-box'
              }}
            >
              {statusOptions.map((s) => (
                <option key={s} value={s}>
                  {s}
                </option>
              ))}
            </select>
          </div>

          <div style={{ minWidth: 0 }}>
            <div style={{ fontSize: 12, color: '#666', marginBottom: 6 }}>Mandated Reporter Status</div>
            <select
              value={staffMrStatus}
              onChange={(e) => setStaffMrStatus(e.target.value)}
              style={{
                width: '100%',
                padding: '10px 12px',
                borderRadius: 8,
                border: '1px solid #ddd',
                boxSizing: 'border-box'
              }}
            >
              {statusOptions.map((s) => (
                <option key={s} value={s}>
                  {s}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* Row 3: Registration Rate + Amount */}
        <div
          style={{
            marginTop: 10,
            display: 'grid',
            gap: 10,
            gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))'
          }}
        >
          <div style={{ minWidth: 0 }}>
            <div style={{ fontSize: 12, color: '#666', marginBottom: 6 }}>Registration Rate</div>
            <select
              value={staffRateType}
              onChange={(e) => setStaffRateType(e.target.value)}
              style={{
                width: '100%',
                padding: '10px 12px',
                borderRadius: 8,
                border: '1px solid #ddd',
                boxSizing: 'border-box'
              }}
            >
              <option value="free">Free</option>
              <option value="normal">Normal</option>
              <option value="fixed">Fixed</option>
            </select>
          </div>

          <div style={{ minWidth: 0 }}>
            <div style={{ fontSize: 12, color: '#666', marginBottom: 6 }}>Registration Amount</div>
            <input
              type="text"
              value={staffRateAmount}
              onChange={(e) => setStaffRateAmount(e.target.value)}
              placeholder={staffRateType === 'fixed' ? 'e.g. 100' : 'Only needed for Fixed'}
              disabled={staffRateType !== 'fixed'}
              inputMode="decimal"
              style={{
                width: '100%',
                padding: '10px 12px',
                borderRadius: 8,
                border: '1px solid #ddd',
                boxSizing: 'border-box',
                opacity: staffRateType !== 'fixed' ? 0.7 : 1
              }}
            />
          </div>
        </div>

        {/* hidden: explicitly clear removed fields (dates + notes) */}
        <div style={{ display: 'none' }}>
          <input value={staffBgDate || ''} onChange={() => {}} />
          <input value={staffMrDate || ''} onChange={() => {}} />
          <input value={staffNotes || ''} onChange={() => {}} />
        </div>

        <div style={{ marginTop: 10, display: 'flex', justifyContent: 'flex-end', gap: 8, flexWrap: 'wrap' }}>
          <button className="btn" onClick={handleUpsert} disabled={staffLoading}>
            Save / Update Staff
          </button>
        </div>
      </div>

      {/* Existing staff list/table (if it overflows, wrap it) */}
      <div style={{ marginTop: 12, overflowX: 'auto', width: '100%' }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {rows.map((r, idx) => (
            <div
              key={String(r?.id || r?.email || idx)}
              onClick={() => setStaffModal({ open: true, staff: r })}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') setStaffModal({ open: true, staff: r });
              }}
              style={{
                border: '1px solid #eee',
                borderRadius: 10,
                padding: 12,
                background: '#fff',
                display: 'flex',
                justifyContent: 'space-between',
                gap: 10,
                flexWrap: 'wrap',
                cursor: 'pointer'
              }}
            >
              <div style={{ minWidth: 0 }}>
                <div style={{ fontWeight: 700 }}>{r?.name || r?.Name || r?.staffName || r?.email || ''}</div>
                <div className="muted" style={{ wordBreak: 'break-word' }}>
                  {r?.email || r?.Email || ''}
                </div>
                <div className="muted">{r?.phone || r?.Phone || ''}</div>
                {String(r?.role || '').trim() ? <div className="muted">Role: {String(r.role).trim()}</div> : null}
              </div>

              <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'center' }}>
                <button
                  className="btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    loadStaffIntoForm(r);
                  }}
                  disabled={staffLoading}
                >
                  Edit
                </button>
                <button
                  className="btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    setStaffModal({ open: true, staff: r });
                  }}
                  disabled={staffLoading}
                >
                  View
                </button>
              </div>
            </div>
          ))}
          {!rows.length ? <div className="muted">No staff rows.</div> : null}
        </div>
      </div>

      {/* Staff flash-card modal */}
      {staffModal.open && staffModal.staff ? (
        <div className="modal-overlay" onClick={() => setStaffModal({ open: false, staff: null })}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 620 }}>
            <button className="close" onClick={() => setStaffModal({ open: false, staff: null })}>
              ×
            </button>

            <h3 style={{ marginTop: 0, marginBottom: 6 }}>Staff Member</h3>

            <div style={{ border: '1px solid #eee', borderRadius: 12, padding: 14, background: '#fff' }}>
              <div style={{ fontSize: 20, fontWeight: 800 }}>
                {staffModal.staff?.name || staffModal.staff?.Name || staffModal.staff?.email || ''}
              </div>

              <div className="muted" style={{ marginTop: 6 }}>
                <div>
                  <strong>Email:</strong> {staffModal.staff?.email || staffModal.staff?.Email || ''}
                </div>
                <div>
                  <strong>Phone:</strong> {staffModal.staff?.phone || staffModal.staff?.Phone || ''}
                </div>
                {String(staffModal.staff?.role || staffModal.staff?.Role || '').trim() ? (
                  <div>
                    <strong>Role:</strong> {String(staffModal.staff?.role || staffModal.staff?.Role).trim()}
                  </div>
                ) : null}
              </div>
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 12 }}>
              <button className="btn" onClick={() => setStaffModal({ open: false, staff: null })}>
                Close
              </button>

              <button
                className="btn primary"
                onClick={() => {
                  loadStaffIntoForm(staffModal.staff);
                  setStaffModal({ open: false, staff: null });
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }}
              >
                Edit
              </button>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
}